import React from 'react'
import './index.scss'
import {useSelector} from "react-redux";

export default function JobFiles() {
    const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);

  const fileExtensionToImage = {
    xls: '/assets/icons/excel-file.svg',
    xlsx: '/assets/icons/excel-file.svg',
    mp4: '/assets/icons/video.svg',
    mov: '/assets/icons/video.svg',
  };

  const getFileTypeImage = (file) => {
    const extension = file?.name?.split('.').pop().toLowerCase();
    if (extension === 'jpeg' || extension === 'jpg' || extension === 'png') {
      return file?.link;
    } else {
      return fileExtensionToImage[extension] || '/assets/icons/file-chat-2.svg';
    }
  };
  const getFileType= (file) => {
    return file?.name?.split('.').pop().toLowerCase();
  };

    return (
      <div className="jobFiles">
        <div className="jobFiles__title">Job files</div>
        <div className="jobFiles__list">
          {
             activeJob?.files?.length ? (
               <>
                 {
                   activeJob?.files?.map((file, index) => (

                   <a target="_blank" href={file?.link} key={index}>
                     <div className="jobFiles__item">
                       <div className="jobFiles__item-wrapper">
                         <div className="jobFiles__item-avatar">
                           <img
                             src={getFileTypeImage(file)}
                             alt="file"
                             style={{
                               ...(getFileType(file) === 'jpeg' || getFileType(file) === 'png' || getFileType(file) === 'jpg') && {
                                 width: '100%',
                                 height: '100%',
                                 borderRadius: '6px',
                               }
                             }}
                           />
                         </div>
                         <div className="jobFiles__item-info">
                           <p className="jobFiles__item-name">{file?.name}</p>
                           <p className="jobFiles__item-date">{file?.created_at}</p>
                         </div>
                       </div>
                     </div>
                     </a>
                   ))
                 }
               </>
             ) : (
               <div className="jobForms__empty">
                 <div><img src="/assets/images/files-empty.svg" alt="empty"/></div>
                 <p className="jobForms__empty-text">
                   You don't have job files
                 </p>
               </div>
             )
          }
        </div>
      </div>
  )
}
